<template>
  <main class="main community" role="main">
    <div class="main_con">
      <!-- <div class="sec_wrap">
        <div class="sub_filter_wrap">
          <div class="select_box">
            <button @click="openSortModal">
              {{ selectedSort.label }}<i class="i_select_s"></i>
            </button>
          </div>
        </div>
      </div> -->
      <div class="comm_tab_wrap">
        <ul>
          <li
            id="comm_tab_1"
            class="comm_tab"
            :class="{ on: comm_list }"
            @click="listView('comm_tab_1')"
          >
            게시글
          </li>
          <li
            id="comm_tab_2"
            class="comm_tab"
            :class="{ on: comm_answer }"
            @click="listView('comm_tab_2')"
          >
            답글
          </li>
        </ul>
      </div>
      <!-- 게시판 리스트 -->
      <div class="con" v-if="comm_list">
        <ul v-if="boardList.length > 0">
          <li
            class="list_item no_list_line"
            v-for="item in boardList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <ListItem :board-type="boardType" :data="item" />
          </li>
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>등록된 글이 없습니다</div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <!-- 답글 리스트 -->
      <div class="con" v-if="comm_answer">
        <ul v-if="boardReplyListMine.length > 0">
          <li
            class="list_ans_item"
            v-for="item in boardReplyListMine"
            :key="item.id"
          >
            <ListAnswerItem
              :board-type="boardType"
              :data="item"
              @goDetail="goDetail"
              @more="openBottomModal"
            />
          </li>
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>등록된 글이 없습니다</div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <SortModal
      :value="selectedSort"
      :show="isSortModal"
      @close="cloasSortModal"
    />
    <BottomModal
      :show="isBottomModal"
      :mode="mode"
      @comme-edit="fnEditComme"
      @close="closeBottomModal"
    />
    <DesignPopup :show="openDesignPopup" :data="popupParams" @close="confirm" />
  </main>
</template>

<script>
import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import ListItem from '@common/components/community/ListItem';
import ListAnswerItem from '@common/components/community/ListAnswerItem';
import SortModal from '@common/components/community/modal/SortModal';
import BottomModal from '@common/components/community/modal/BottomModal';
import DesignPopup from '@/common/components/modal/DesignPopup.vue';

export default {
  name: 'community-board-mine',
  description: '커뮤니티 > 내 작성 글 리스트',
  components: {
    ListItem,
    ListAnswerItem,
    SortModal,
    BottomModal,
    DesignPopup,
  },
  data() {
    return {
      boardType: 'BOARD',
      params: {
        page: 1,
        pageSize: 1000,
        myPost: 'Y',
        orderType: 'CREATED_AT_DESC',
      },
      selectedSort: { label: '최신 순', value: 'CREATED_AT_DESC' },
      isSortModal: false,
      comm_list: true,
      comm_answer: false,
      isBottomModal: false,
      mode: '',
      isReportModal: false,
      selectedComment: '',
      openDesignPopup: false,
      popupParams: {},
      popupMode: '',
      modalVal: {}, // 선택된 댓글 데이터
    };
  },
  created() {
    this.getList();
    this.getReplyList();

    console.log('boardReplyListMineboardReplyListMine');
    console.log(this.boardReplyListMine);
  },
  computed: {
    ...communityGetters({
      boardList: communityTypes.FETCH_BOARD_LIST,
      boardReplyListMine: communityTypes.FETCH_BOARD_REPLY_LIST_MINE,
    }),
  },
  methods: {
    ...communityMapActions([
      communityTypes.FETCH_BOARD_LIST,
      communityTypes.FETCH_BOARD_REPLY_LIST_MINE,
      communityTypes.DELETE_BOARD_REPLY,
    ]),
    async getList() {
      await this[communityTypes.FETCH_BOARD_LIST](this.params);
    },
    async getReplyList() {
      await this[communityTypes.FETCH_BOARD_REPLY_LIST_MINE](this.params);
    },
    openSortModal() {
      this.isSortModal = true;
    },
    cloasSortModal(val) {
      if (val) {
        this.selectedSort = val;
        this.params.orderType = val.value;
        this.getList();
      }
      this.isSortModal = false;
    },
    goDetail(boardId) {
      this.$router.push({
        name: 'Board.Detail',
        params: { id: boardId, isRead: 'Y' },
      });
    },
    listView(id) {
      var listElement = document.querySelector('.comm_tab.on');

      console.log('listElement');
      console.log(listElement);
      if (listElement != null) {
        listElement.classList.remove('on');
      }
      var someElement = document.getElementById(id);
      someElement.classList.add('on');

      if (id == 'comm_tab_1') {
        this.comm_list = true;
        this.comm_answer = false;
      } else {
        this.comm_list = false;
        this.comm_answer = true;
      }
    },
    fnEditPost(val) {
      if (val === 'MODIFY') {
        this.$router.push({
          name: 'Board.Write',
          query: { boardId: this.params.boardId },
        });
      } else {
        this.popupParams = {
          type: 'confirm',
          msg: '게시글을 삭제 하시겠습니까?',
        };
        this.popupMode = 'POST_DELETE';
        this.openDesignPopup = true;
      }
    },
    fnEditComme(val) {
      if (val === 'DELETE') {
        this.popupParams = {
          type: 'confirm',
          msg: '답글을 삭제 하시겠습니까?',
        };
        this.popupMode = 'COMME_DELETE';
        this.openDesignPopup = true;
      }
    },
    confirm(isSave) {
      if (isSave) {
        if (this.popupMode === 'COMME_DELETE') {
          console.log('modalValmodalVal');
          console.log(this.modalVal);
          this[communityTypes.DELETE_BOARD_REPLY]({ id: this.modalVal.id });
        }
        this.popupParams = { type: 'alert', msg: '삭제되었습니다' };
      } else {
        this.openDesignPopup = false;
        if (this.popupParams.type === 'alert') {
          this.closeBottomModal();
          this.getReplyList();
        }
        this.popupMode = '';
      }
    },
    openBottomModal(mode, val) {
      this.isBottomModal = true;
      this.mode = mode;
      this.modalVal = val;
    },
    closeBottomModal() {
      this.isBottomModal = false;
    },
  },
};
</script>

<style></style>
